import {deleteRequest, getRequest, putRequest} from "../api";

const USER_REGISTRY = "/iroh/registry/user";

export const fetchUserRegistry = key => {
  if (Array.isArray(key)) {
    const params = key.map(k => `keys=${k}`).join("&");

    return getRequest(`${USER_REGISTRY}?${params}`);
  } else {
    return getRequest(`${USER_REGISTRY}/${encodeURIComponent(key)}`);
  }
};

export const updateUserRegistry = (key, value) => {
  return putRequest(`${USER_REGISTRY}/${encodeURIComponent(key)}`, value);
};

export const deleteUserRegistry = key => {
  return deleteRequest(`${USER_REGISTRY}/${encodeURIComponent(key)}`);
};
